/**
 * <s-product-gallery>: on desktop, clicking a thumbnail promotes it to the large main photo.
 * Clicking the main photo keeps its default behavior (opens the zoom dialog).
 * On mobile the gallery is a swipe slider, so clicks pass straight through.
 */
class SProductGallery extends HTMLElement {
  #desktop = window.matchMedia('(min-width: 768px)');

  connectedCallback() {
    this.addEventListener('click', this.#onClick, { capture: true });
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick, { capture: true });
  }

  #onClick = (event) => {
    if (!this.#desktop.matches) return;
    const item = event.target.closest('[data-gallery-item]');
    if (!item || !this.contains(item) || item.hasAttribute('data-gallery-main')) return;

    // Cancel the zoom command for thumbnails; promote instead.
    event.preventDefault();
    event.stopPropagation();

    const current = this.querySelector('[data-gallery-main]');
    if (current) {
      current.removeAttribute('data-gallery-main');
      current.style.removeProperty('order');
      current.style.removeProperty('grid-column');
    }
    item.setAttribute('data-gallery-main', '');
    item.style.order = '-1';
    item.style.gridColumn = '1 / -1';
    item.querySelector('button')?.focus({ preventScroll: true });
  };
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
